import { Button } from '@fluentui/react-components'
import { GlobeShield48Color } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { ErrorPageLayout } from '../ErrorPageLayout/ErrorPageLayout'

export const VpnErrorPage = () => {
  const { t } = useTranslation()

  return (
    <ErrorPageLayout
      icon={<GlobeShield48Color aria-hidden="true" />}
      title={t('vpnError.title')}
      body={t('vpnError.body')}>
      <Button appearance="primary" onClick={() => window.location.reload()}>
        {t('vpnError.reload')}
      </Button>
    </ErrorPageLayout>
  )
}
